import React from 'react';
import { LoadingSpinner } from '@crx-dev/hss-react-components';
import { useQuery } from 'react-query';
import { makeRequest } from '@crx-dev/hss-react-infrastructure/dist';
import { Route, RouteComponentProps, Switch, useRouteMatch } from 'react-router-dom';
import EntriesList from './EntriesList';
import { RegisterSummary } from '../Registers/types/RegisterSummary';
import ReceivedForm from './forms/ReceivedForm';
import SuppliedForm from './forms/SuppliedForm';
import QuarantineForm from './forms/QuarantineForm';
import DestroyedForm from './forms/DestroyedForm';
import AmendmentForm from './forms/AmendmentForm';
import StockCheckForm from './forms/StockCheckForm';

interface RouteInfo {
    registerId: string;
}

interface DrugEntriesProps extends RouteComponentProps<RouteInfo> {}

function Register({ match }: DrugEntriesProps) {
    let { path } = useRouteMatch();
    let registerId = match.params.registerId;
    const { data, isLoading } = useQuery<RegisterSummary>(['register-summary', registerId], () =>
        makeRequest({
            method: 'GET',
            path: `/api/v1/ControlDrugRegister/${registerId}`
        })
    );

    if (isLoading) {
        return <LoadingSpinner />;
    }

    if (!data) {
        return <div>Error</div>;
    }

    return (
        <Switch>
            <Route exact path={path} render={props => <EntriesList {...props} registerSummary={data} />} />
            <Route
                exact
                path={`${path}/received`}
                render={props => <ReceivedForm {...props} registerSummary={data} />}
            />
            <Route
                exact
                path={`${path}/supplied`}
                render={props => <SuppliedForm {...props} registerSummary={data} />}
            />
            <Route
                exact
                path={`${path}/quarantine`}
                render={props => <QuarantineForm {...props} registerSummary={data} />}
            />
            <Route
                exact
                path={`${path}/destroy`}
                render={props => <DestroyedForm {...props} registerSummary={data} />}
            />
            <Route
                exact
                path={`${path}/amendment`}
                render={props => <AmendmentForm {...props} registerSummary={data} />}
            />
            <Route
                exact
                path={`${path}/stockCheck`}
                render={props => <StockCheckForm {...props} registerSummary={data} />}
            />
        </Switch>
    );
}

export default Register;
